/**
 * Deposit View
 */

define(function(require, exports, module) {
    'use strict';
    var CashierPaymentView = require('portlets/cashier/cashier.payment.view');
    var DepositMethodCollection = require('portlets/cashier/deposit/deposit.method.collection');
    var DepositMethodView = require('portlets/cashier/deposit/deposit.method.view');
    var _ = require('underscore');
    var core = require('core');
    var config = require('config');
    var utils = require('utils');

    module.exports = CashierPaymentView.extend({

        MethodView: DepositMethodView,

        MethodsCollection: DepositMethodCollection,

        initialize: function() {
            CashierPaymentView.prototype.initialize.apply(this, arguments);

            var paypalMerchantValue = config.get('paypalMerchantValue');

            if (paypalMerchantValue) {
                var uuid = utils.guid().replace(/-/g, '');

                this.initFraud(paypalMerchantValue, uuid);

                _.extend(this.options.config, { uuidForFraud: uuid });
            }
        },

        subscribe: function() {
            CashierPaymentView.prototype.subscribe.apply(this, arguments);

            this.listenTo(core, 'deposit:wirecard deposit:paysafe card:added', this.updatePortlet.bind(this));
        },

        template: function(options) {
            return this.tmpl('deposit', options);
        },

        initFraud: function(merchant, uuid) {
            this._initFraudJSONScript(merchant, uuid);
            this._initFraudScript();
        },

        _initFraudJSONScript: function(merchant, uuid) {
            var fraudJSONScript = document.createElement('script');

            fraudJSONScript.type = 'application/json';
            fraudJSONScript.setAttribute('fncls', 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99');
            fraudJSONScript.innerText = JSON.stringify({
                'f': uuid,
                's': merchant
            });

            document.body.appendChild(fraudJSONScript);
        },

        _initFraudScript: function() {
            var domain;
            var doc;
            var where;

            var scriptBaseURL = 'https://www.paypalobjects.com/webstatic/r/fb/';

            var iframe = document.createElement('iframe');
            iframe.src = 'about:blank';
            iframe.title = '';
            iframe.role = 'presentation'; // a11y
            iframe.classList.add('fn-fraud-script');
            (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0';

            where = document.getElementsByTagName('script');
            where = where[where.length - 1];
            where.parentNode.insertBefore(iframe, where);

            try {
                doc = iframe.contentWindow.document;
            } catch (e) {
                domain = document.domain;
                iframe.src = 'javascript:var d=document.open();d.domain=\'' + domain + '\';void(0);'; // eslint-disable-line
                doc = iframe.contentWindow.document;
            }

            doc.open()._l = function() {
                var js = this.createElement('script');

                if (domain) {
                    this.domain = domain;
                }

                js.id = 'js-iframe-async';
                js.src = scriptBaseURL + 'fb-all-prod.pp.min.js';

                this.body.appendChild(js);
            };

            doc.write('<body onload="document._l();">');
            doc.close();
        },

        _removeFraudScript: function() {
            Array.prototype.forEach.call(document.querySelectorAll('.fn-fraud-script'), function(script) {
                script.remove();
            });
        },

        close: function() {
            CashierPaymentView.prototype.close.apply(this, arguments);
            this._removeFraudScript();
        },
    });
});
